import * as React from "react";

import { Checkbox, Form, Input } from "antd";
const SignRouteSurvey = ({
	questionList,
	selectKeys,
	setSelectKeys,
	selectEtc,
	setSelectEtc,
}) => {
	/**
	 * 체크 박스 추가
	 * @param checkedValues
	 */
	const onChangeCheckValue = (values, idx) => {
		let list = [...selectKeys];
		list[idx] = values;
		setSelectKeys(list);
	};

	/**
	 * 기타 문구 작성
	 * @param e
	 * @param idx
	 */
	const onChangeEtc = (e, idx) => {
		let list = [...selectEtc];
		list[idx] = e.target?.value;
		setSelectEtc(list);
	};

	return (
		<>
			<p className={`signup-sub-title signup-border`}>
				가입 질문에 답해주세요.
			</p>

			<Form layout={`vertical`} className={`signup-userInfo-div`}>
				{questionList?.map((item, idx) => {
					let exampleList = item?.example_list?.split(",");
					const options = [
						...exampleList.map((example) => {
							if (example !== "기타") {
								return {
									label: example,
									value: example,
								};
							} else {
								return {
									label: (
										<div className={`route-etc-div`}>
											기타
											<Input
												type={"text"}
												className={`route-etc-input`}
												placeholder={`직접 입력`}
												disabled={!selectKeys[idx]?.includes("기타")}
												value={selectEtc[idx]}
												onChange={(e) => onChangeEtc(e, idx)}
											/>
										</div>
									),
									value: example,
								};
							}
						}),
					];
					return (
						<Form.Item
							label={item?.question}
							labelAlign="left"
							colon={false}
							fieldKey={`question-${idx}`}
							key={`question-${idx}`}
						>
							<Checkbox.Group
								options={options}
								value={selectKeys[idx]}
								onChange={(value) => onChangeCheckValue(value, idx)}
								className={`route-group`}
							/>
						</Form.Item>
					);
				})}
			</Form>
		</>
	);
};
export default SignRouteSurvey;
